import type { QueryClient } from '@tanstack/react-query'

export async function invalidateIssueViews(queryClient: QueryClient, projectId?: string) {
  const invalidations = [
    queryClient.invalidateQueries({ queryKey: ['issue'] }),
    queryClient.invalidateQueries({ queryKey: ['my-issues'] }),
    queryClient.invalidateQueries({ queryKey: ['dashboard-review'] }),
    queryClient.invalidateQueries({ queryKey: ['project-value-dashboard'] }),
    queryClient.invalidateQueries({ queryKey: ['people-performance'] }),
    queryClient.invalidateQueries({ queryKey: ['header-capacity'] }),
    queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  ]

  if (projectId) {
    invalidations.push(queryClient.invalidateQueries({ queryKey: ['issues', projectId] }))
  } else {
    invalidations.push(queryClient.invalidateQueries({ queryKey: ['issues'] }))
  }

  await Promise.all(invalidations)
}

export async function invalidateWorkloadViews(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['dashboard-review'] }),
    queryClient.invalidateQueries({ queryKey: ['people-performance'] }),
    queryClient.invalidateQueries({ queryKey: ['header-capacity'] }),
  ])
}

export async function invalidateProjectConfigurationViews(queryClient: QueryClient, projectId: string) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['project', projectId] }),
    queryClient.invalidateQueries({ queryKey: ['projects'] }),
    queryClient.invalidateQueries({ queryKey: ['project-values-projects'] }),
    queryClient.invalidateQueries({ queryKey: ['members', projectId] }),
    queryClient.invalidateQueries({ queryKey: ['statuses', projectId] }),
    queryClient.invalidateQueries({ queryKey: ['labels', projectId] }),
    queryClient.invalidateQueries({ queryKey: ['components', projectId] }),
    queryClient.invalidateQueries({ queryKey: ['milestones', projectId] }),
    invalidateIssueViews(queryClient, projectId),
  ])
}

export async function invalidateUserPresentationViews(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['users'] }),
    queryClient.invalidateQueries({ queryKey: ['members'] }),
    queryClient.invalidateQueries({ queryKey: ['projects'] }),
    queryClient.invalidateQueries({ queryKey: ['project'] }),
    queryClient.invalidateQueries({ queryKey: ['comments'] }),
    queryClient.invalidateQueries({ queryKey: ['notifications'] }),
    invalidateIssueViews(queryClient),
  ])
}
